import React, { useMemo } from 'react'

import { API_URL } from '../constants'

import { useItems } from '../../hooks'

import FormField, { FIELD_TYPES } from '../../components/FormField'

const IncidentDivisionSelectList = ({
  field: { label, name, defaultValue },
  item,
  onChange,
}) => {
  const [{ response: divisions, isLoading, error }] = useItems(API_URL)

  const field = useMemo(() => {
    if (isLoading || error || !divisions) return null
    return {
      type: FIELD_TYPES.SELECT,
      label: label || 'Incident Division',
      name,
      defaultValue,
      options: divisions.map((p) => ({
        label: p.name,
        value: p.id,
      })),
    }
  }, [name, label, defaultValue, divisions, isLoading, error])

  if (field === null)
    return (
      <div>
        <label>{label}</label>
        <div>
          Loading Incident Divisions...{' '}
          <i className="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    )

  return <FormField field={field} item={item} onChange={onChange} />
}

export default IncidentDivisionSelectList
